var _rect, _rect2, _path, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 14,
    fill: "#F4F4F4",
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 76,
    height: 60,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#C9C9C9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 73L49 58L60 69L72 56L85 73",
    stroke: "#8F8F8F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 47,
    r: 5,
    fill: "#B0B0B0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 101,
    textAnchor: "middle",
    fill: "#7F7F7F",
    fontSize: 10,
    fontFamily: "Arial, sans-serif"
  }, "LOGO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoPlaceholder);
export default __webpack_public_path__ + "static/media/company-logo-placeholder.ab856733b78e2c7ac22fac0742ebe9a5.svg";
export { ForwardRef as ReactComponent };